<div class="outer-container">

    <div fxLayout="row" fxLayoutAlign="space-between">
        <div>
          <h3>My Courses</h3>
        </div>

        <button *ngIf="studentCourseData?.IsTeacher"
        class="button secondary-button"
        [routerLink]="['/ELearning/Curriculum']">+ Add new student curriculum</button>

    </div>

    <div> 

      <mat-card  
      class="card"
        *ngFor="let student of groupedStudents; let i = index">

        <div class="mat-card-header"> 

                <div 
                  *ngIf="studentCourseData?.IsTeacher"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  class="topClassInfo">

                    <i class="fas fa-user-circle fa-3x mar-right-5" [ngStyle]="{'color':colors[i%colorsLength]}"></i>

                    <span>
                      <b>{{student.Classes[0].StudentFirstName + ' ' + student.Classes[0].StudentLastName}}</b>
                    </span>

                </div>
                 
        </div>
    
        <div>
            <mat-card-content>

                <div class="classes" fxLayout="row wrap" fxLayoutAlign="start">

                  <div 
                    *ngFor="let class of student.Classes"
                    class="student-card"
                    fxLayout="column"
                    (click)="studentClassAction(class)">

                      <div class="card-header"
                        [ngStyle]="{
                          'background': 'linear-gradient(180deg, rgba(0,0,0,45%) 0%, rgba(255, 255, 255, 0) 60%), 
                            url(' + imagePath + class.ImagePath + ')',
                          'background-size': '100%'
                        }"
                      >
                        {{class.ClassName}}
                      </div>
                  
                  </div>
                  
                </div>            

            </mat-card-content>
        </div>
        
      </mat-card>

    </div>



    <div *ngIf="!curriculumDataReceived" class="spinner-wrapper">
      <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
    </div>

</div>
 